import React, { cloneElement } from 'react';
import { ModalTrigger } from './Modals.jsx';

const ButtonModal = (props) => (
    <ModalTrigger getPartners={props.getPartners}>
        {(isVisible, showModal, hideModal)=>
            <button
                onClick={showModal}
                className={props.btnClassName}
                disabled={!props.isEnabled}
            >
                <span className={props.glyphiconBtn} />
                {` ${props.btnText}`}
                { isVisible &&
                    <div>
                        {cloneElement(props.children, { isVisible, showModal, hideModal })}
                    </div>
                }
            </button>
        }
    </ModalTrigger>

)
export default ButtonModal;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/ButtonModal.jsx